export default __webpack_public_path__ + "cb61919b21debc45b19e8389d0ebe0c0.svg";